import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./AuthInput.css";


const AuthInput = ({
  label,
  name,
  placeholder,
  type = "text",
  icon,
  value,
  onChange,
  error,
  inputClass,
  required = true,
}) => {
  return (
    <div className="coolinput w-100">
      <label className="text">
        {label} {required && <span className="req">*</span>}
      </label>

      <div className="input-wrapper">
        <input
          type={type}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          className={
            typeof inputClass === "function"
              ? inputClass(name)
              : inputClass || "input w-100"
          }
        />
        {icon && <FontAwesomeIcon icon={icon} className="input-icon" />}
      </div>

      {error && <span className="error fade-in">{error}</span>}
    </div>
  );
};

export default AuthInput;
